import store from '@/store';
import { api } from '@/utils/api';
import axios from '@axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCustomers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        const params = {
          businessID,
          pageNumber: queryParams.page || 1,
          pageSize: queryParams.perPage || 10,
          searchTerm: queryParams.q || '',
        };

        api
          .get(`/CustomersFBR/GetByPagination/${businessID}`, { params })
          .then((response) => {
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              reject('Error fetching Customers list');
            }
          })
          .catch((error) => reject(error));
      });
    },
    fetchCustomer(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        const userID = store.state.user.userID || store.state.user.id;

        if (!userID) {
          console.error('User ID not found in store');
          return Promise.reject(new Error('User ID not found. Please login again.'));
        }

        // Use the new API endpoint with query parameters for editing
        api
          .get(`/CustomersFBR/LoadSelectedData/${businessID}?id=${id}&userID=${userID}`)
          .then((response) => {
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data.entity);
            } else {
              console.error('Error occurred ---> :', response.data);
              reject('Error fetching Customer data');
            }
          })
          .catch((error) => {
            console.error('Error occurred ---> :', error);
            reject(error);
          });
      });
    },
    addCustomer(ctx, customerData) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID || store.state.user.id;

      // Check if userID exists, if not, throw an error
      if (!userID) {
        console.error('User ID not found in store');
        return Promise.reject(new Error('User ID not found. Please login again.'));
      }

      // Prepare payload with entity wrapper structure
      const payload = {
        entity: {
          id: 0,
          businessID: businessID,
          code: customerData.code || '',
          name: customerData.companyName || '',
          shortName: customerData.shortName || '',
          commissionPercent: customerData.commissionPercent || 0,
          accountID: customerData.accountID || 0,
          accountTitle: customerData.accountTitle || '',
          category: customerData.category || '',
          address: customerData.address || '',
          province: customerData.province || '',
          gstNumber: customerData.gstNo || '',
          ntnNumber: customerData.ntn || '',
          cnicNumber: customerData.cnicNumber || '',
          contactPerson: customerData.contactPerson || '',
          cellNumber: customerData.cellNo || '',
          whatsappOrUAN: customerData.whatsapp || '',
          telephoneNumber: customerData.telephoneNumber || '',
          email: customerData.email || '',
          website: customerData.website || '',
          remarks: customerData.remarks || '',
          isActive: customerData.isActive !== undefined ? customerData.isActive : true,
          isDeleted: false,
          deletedByUserID: 0,
          addedBy: userID,
          addedOn: new Date().toISOString(),
          updatedBy: userID,
          updatedOn: new Date().toISOString(),
          metaAddedBy: store.state.user?.fullName || store.state.user?.name || '',
          metaUpdatedBy: store.state.user?.fullName || store.state.user?.name || '',
        },
      };

      return new Promise((resolve, reject) => {
        api
          .post(`/CustomersFBR/Save/${businessID}?userID=${userID}`, payload)
          .then((response) => {
            console.log('Customer Save Response:', response, response.data.id);

            resolve(response.data.data.id);
          })
          .catch((error) => {
            console.error('Add Customer Error:', error);
            reject(error);
          });
      });
    },
    bulkUploadCustomer(ctx, customerData) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID;

      return new Promise((resolve, reject) => {
        api
          .post(`/CustomersFBR/BulkUpload/${businessID}?userID=${userID}`, customerData)
          .then((response) => {
            resolve(response);
          });
      });
    },
    editCustomer(ctx, customerData) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID || store.state.user.id;

      // Check if userID exists, if not, throw an error
      if (!userID) {
        console.error('User ID not found in store');
        return Promise.reject(new Error('User ID not found. Please login again.'));
      }

      // Prepare payload with entity wrapper structure
      const payload = {
        entity: {
          id: customerData.id || 0,
          businessID: businessID,
          code: customerData.code || '',
          name: customerData.companyName || '',
          shortName: customerData.shortName || '',
          commissionPercent: customerData.commissionPercent || 0,
          accountID: customerData.accountID || 0,
          accountTitle: customerData.accountTitle || '',
          category: customerData.category || '',
          address: customerData.address || '',
          province: customerData.province || '',
          gstNumber: customerData.gstNo || '',
          ntnNumber: customerData.ntn || '',
          cnicNumber: customerData.cnicNumber || '',
          contactPerson: customerData.contactPerson || '',
          cellNumber: customerData.cellNo || '',
          whatsappOrUAN: customerData.whatsapp || '',
          telephoneNumber: customerData.telephoneNumber || '',
          email: customerData.email || '',
          website: customerData.website || '',
          remarks: customerData.remarks || '',
          isActive: customerData.isActive !== undefined ? customerData.isActive : true,
          isDeleted: false,
          deletedByUserID: 0,
          addedBy: userID,
          addedOn: new Date().toISOString(),
          updatedBy: userID,
          updatedOn: new Date().toISOString(),
          metaAddedBy: store.state.user?.fullName || store.state.user?.name || '',
          metaUpdatedBy: store.state.user?.fullName || store.state.user?.name || '',
        },
      };

      return new Promise((resolve, reject) => {
        api
          .post(`/CustomersFBR/Save/${businessID}?userID=${userID}`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.error('Edit Error --->:', error);
            reject(error);
          });
      });
    },
    deleteCustomer(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        api
          .delete(`/CustomersFBR/Delete/${id}/${businessID}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    setCustomerStatus(ctx, { id, status }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        api
          .post(`/CustomersFBR/SetStatus/${businessID}`, { id, status })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    bulkUploadCustomers(ctx, chunkData) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        const userID = store.state.user.userID || store.state.user.id;

        if (!userID) {
          console.error('User ID not found in store');
          return Promise.reject(new Error('User ID not found. Please login again.'));
        }

        // Prepare bulk upload payload - direct array of customer entities matching new API schema
        const payload = chunkData.map((customer) => ({
          id: 0,
          businessID: businessID,
          code: customer.code || '',
          name: customer.companyName || '', // Map companyName to name
          shortName: customer.shortName || '',
          commissionPercent: customer.commissionPercent || 0,
          accountID: customer.accountID || 0,
          accountTitle: customer.accountTitle || '',
          category: customer.category || '',
          address: customer.address || '',
          province: customer.province || '',
          gstNumber: customer.gstNo || '', // Map gstNo to gstNumber
          ntnNumber: customer.ntn || '', // Map ntn to ntnNumber
          cnicNumber: customer.cnicNumber || '',
          contactPerson: customer.contactPerson || '',
          cellNumber: customer.cellNo || '', // Map cellNo to cellNumber
          whatsappOrUAN: customer.whatsapp || '', // Map whatsapp to whatsappOrUAN
          telephoneNumber: customer.telephoneNumber || '',
          email: customer.email || '',
          website: customer.website || '',
          remarks: customer.remarks || '',
          isActive: customer.isActive !== undefined ? customer.isActive : true,
          isDeleted: false,
          deletedByUserID: 0,
          addedBy: userID,
          addedOn: new Date().toISOString(),
          updatedBy: userID,
          updatedOn: new Date().toISOString(),
          metaAddedBy: store.state.user?.fullName || store.state.user?.name || '',
          metaUpdatedBy: store.state.user?.fullName || store.state.user?.name || '',
        }));

        api
          .post(`/CustomersFBR/BulkUpload/${businessID}?userID=${userID}`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.error('Bulk Upload Error:', error);
            reject(error);
          });
      });
    },
    viewSelectedCustomer(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        const userID = store.state.user.userID || store.state.user.id;

        if (!userID) {
          console.error('User ID not found in store');
          return Promise.reject(new Error('User ID not found. Please login again.'));
        }

        // Use the new API endpoint with customer ID and user ID as parameters
        api
          .get(`/CustomersFBR/LoadSelectedData/${businessID}?id=${id}&userID=${userID}`)
          .then((response) => {
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data.entity);
            } else {
              console.error('Error occured ---> :', response.data);
              reject('Error fetching Customer data');
            }
          })
          .catch((error) => {
            console.error('Error occured ---> :', error);
            reject(error);
          });
      });
    },
    exportCustomers(ctx, { searchTerm = '' } = {}) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        api
          .get(`/CustomersFBR/Export/${businessID}`, {
            params: { searchTerm },
          })
          .then((response) => {
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data);
            } else {
              reject('Error exporting customers');
            }
          })
          .catch((error) => {
            console.error('Export Error:', error);
            reject(error);
          });
      });
    },
  },
};
